// src/app/shared/lucide-icons.ts
import {
  Home,
  List,
  MapPin,
  FileText,
  FileCheck,
  LogOut,
  MenuIcon,
  Clock,
  BarChart3,
  PieChart,
  Columns2,
  CalendarRange,
  Send,
  PlusCircle,
  CheckCircle,
  Download,
  Bell,
  MessageSquarePlus,
  Mail,
  Calculator,
  Receipt,
  TrendingUp,
  BellRing,
  LifeBuoy,
  HelpCircle,
  Video,
  UserCog,
  User,
  Building,
  ChevronLeft,
  ChevronRight,
  Plus,
  Activity,
  Settings2,
  Droplets,
  Thermometer,
  Flame,
  Snowflake,
  Wind,
  Zap,
  ReceiptText,
  MessageSquareMore,
  Camera,
  Sun,
  Droplet,
  ArrowRight,
  Archive,
  Trash2,
  Calendar,
  CalendarDays,
  SlidersHorizontal,
  PanelLeft,
  LayoutGrid,
  ListIcon,
  Gauge,
  Check,
  TrendingDown,
  X,
  Lightbulb,
  MessagesSquare,
  Loader,
} from 'lucide-angular';

export const APP_ICONS = {
  Home,
  List,
  MapPin,
  FileText,
  Loader,
  FileCheck,
  LogOut,
  Gauge,
  Check,
  MenuIcon,
  Clock,
  BarChart3,
  PieChart,
  Columns2,
  CalendarRange,
  Send,
  PlusCircle,
  CheckCircle,
  Download,
  Bell,
  MessageSquarePlus,
  Mail,
  Calculator,
  Receipt,
  TrendingUp,
  BellRing,
  LifeBuoy,
  HelpCircle,
  Video,
  UserCog,
  User,
  Building,
  ChevronLeft,
  ChevronRight,
  Plus,
  Activity,
  Settings2,
  Droplets,
  Thermometer,
  Flame,
  Snowflake,
  Wind,
  Zap,
  ReceiptText,
  MessageSquareMore,
  Camera,
  Sun,
  Droplet,
  ArrowRight,
  Archive,
  Trash2,
  Calendar,
  CalendarDays,
  SlidersHorizontal,
  PanelLeft,
  LayoutGrid,
  ListIcon,
  TrendingDown,
  X,
  Lightbulb,
  MessagesSquare,
};
